<template>
    <div>
        <div id="Waves">
            <!-- Header -->
            <div class="header py-7 py-lg-8 pt-lg-9">
                <b-container>
                    <!--          <b-img id="404img" src="https://i.imgur.com/Tkt1nmt.jpg"></b-img>-->
                    <div class="header-body text-center mb-7">

                        <b-row class="justify-content-center">
                            <b-col xl="4" lg="4" md="6" class="">
                                <b-img src="/img/brand/lock.png" rounded="circle" class="access-lock"></b-img>
                            </b-col>
                            <b-col xl="8" lg="8" md="6" class="text-left">
                                <h1 class="text-danger text-left forbidden">Access is Restricted</h1>
                                <base-button size="sm" style="width:200px;" type="danger" class="mt-3">
                                    <span class="text-white h4">Contact Administrator</span>
                                </base-button>
                            </b-col>
                        </b-row>
                    </div>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "RestrictedPage",
		mounted() {
			document.title = 'Access Restricted'
		}
	};
</script>

<style scoped>

</style>